export const MAX_READINESS = 150;
export const READINESS_STEP = 5;

export function toISODate(date) {
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
  const parsed = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsed.getTime())) return null;
  const month = `${parsed.getMonth() + 1}`.padStart(2, "0");
  const day = `${parsed.getDate()}`.padStart(2, "0");
  return `${parsed.getFullYear()}-${month}-${day}`;
}

/** Rule 2a: Effective from is disabled on days covered by the employee's other pay plans. */
export function isCoveredByRanges(date, ranges = []) {
  const iso = toISODate(date);
  if (!iso) return false;
  return ranges.some((range) => iso >= range.from && (!range.to || iso <= range.to));
}

/** Rule 2a: Effective to is disabled before Effective from and on/after a later plan's start. */
export function isEffectiveToDisabled(date, effectiveFrom, nextConflictDate) {
  const iso = toISODate(date);
  if (!iso) return false;
  if (effectiveFrom && iso < effectiveFrom) return true;
  return Boolean(nextConflictDate) && iso >= nextConflictDate;
}

function toFiniteNumber(value) {
  if (value == null || value === "") return NaN;
  return Number(value);
}

function roundMoney(value) {
  return Math.round(value * 100) / 100;
}

/** Rule 3c: slider X% → Min + (Max − Min) × X / 150. */
export function salaryForReadiness(rangeMin, rangeMax, readiness) {
  const min = toFiniteNumber(rangeMin);
  const max = toFiniteNumber(rangeMax);
  if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
  return roundMoney(min + ((max - min) * readiness) / MAX_READINESS);
}

/** Rule 3c: ((Base − Min) / (Max − Min)) × 150, clamped 0–150; null when undefined. */
export function readinessForSalary(rangeMin, rangeMax, salary) {
  const min = toFiniteNumber(rangeMin);
  const max = toFiniteNumber(rangeMax);
  const amount = toFiniteNumber(salary);
  if (!Number.isFinite(amount)) return null;
  if (!Number.isFinite(min) || !Number.isFinite(max) || max <= min) return null;
  const raw = ((amount - min) / (max - min)) * MAX_READINESS;
  return Math.min(MAX_READINESS, Math.max(0, raw));
}

export function snapReadiness(readiness) {
  return Math.round(readiness / READINESS_STEP) * READINESS_STEP;
}
